const styles = theme => ({
    body: {
        backgroundColor: theme.palette.background.default,
        padding: 0
    }
});

export default styles;